import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '@shared/auth/useAuth';
import { PendingStepsBanner } from '../components/PendingStepsBanner';

const TABS = [
  { to: 'sites', label: 'Sites' },
  { to: 'commission', label: 'Commission' },
  { to: 'settings', label: 'Settings' },
];

export function AdminShell() {
  const { user, roles, logout } = useAuth();

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 20px',
          borderBottom: '1px solid var(--nx-border)',
          background: 'var(--nx-bg2)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <strong
            style={{
              fontFamily: 'var(--nx-ff-h)',
              letterSpacing: '0.14em',
              background: 'var(--nx-grad)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            NEXSOSS PLATFORM ADMIN
          </strong>
          <nav style={{ display: 'flex', gap: 4 }}>
            {TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                style={({ isActive }) => ({
                  padding: '6px 14px',
                  borderRadius: 'var(--nx-r)',
                  textDecoration: 'none',
                  color: isActive ? 'var(--nx-white)' : 'var(--nx-muted)',
                  background: isActive ? 'var(--nx-bg3)' : 'transparent',
                })}
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 13 }}>
          <span style={{ color: 'var(--nx-muted)' }}>
            {user?.displayName} · {roles.map((r) => r.replace('nexsoss:', '')).join(', ')}
          </span>
          <button type="button" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </header>

      {/* Shell-level, so an outstanding checklist follows you across
          panes. See PendingStepsBanner's own docstring for why that
          placement is the point rather than a convenience. */}
      <PendingStepsBanner />

      <main style={{ flex: 1, minHeight: 0, padding: 20, overflow: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
